import { useEffect, useState } from "react";

import apiClient from "../services/apiClient";
import TelegramConnectDialog from "./TelegramConnectDialog";
import "./TelegramConnectDialog.css";

// 계정 메뉴의 '텔레그램 알림'(2026-09-30). 연결을 누르면 @ginecho_bot 이 열리고, 거기서 '시작' 을
// 누르면 이 계정에 이어진다. 출제·학습 완료·레벨테스트를 알려 주고, 방마다 '레벨테스트만' 을 고를 수 있다.
// 서버: api/echo/teacher_telegram.py

const TelegramConnect = () => {
  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const load = () =>
    apiClient
      .get("/api/v1/echo/teacher/telegram", { withAuth: true })
      .then((response) => setData(response.data))
      .catch(() => setData(null));

  useEffect(() => {
    load();
  }, []);

  if (!data) return null;

  const post = (body) => apiClient.post("/api/v1/echo/teacher/telegram", body, { withAuth: true });

  const connect = () => {
    setMessage("");
    setDialogOpen(true);
  };

  const changeScope = async (id, scope) => {
    const response = await post({ action: "scope", id, scope });
    setData(response.data);
  };

  const disconnect = async (id) => {
    const response = await post({ action: "disconnect", id });
    setData(response.data);
  };

  const test = async () => {
    const response = await post({ action: "test" });
    setMessage(response.data.sent ? "테스트 알림을 보냈어요. 텔레그램을 확인해 주세요." : "보내지 못했어요. 연결을 다시 해 주세요.");
  };

  const chatList = data.chat_list || [];

  return (
    <div className="user-menu__telegram">
      <div className="user-menu__academy-title">텔레그램 알림</div>
      {!data.enabled ? (
        <p className="user-menu__telegram-help">준비 중이에요.</p>
      ) : (
        <>
          <p className="user-menu__telegram-help">출제 · 학습 완료 · 레벨테스트 소식을 텔레그램으로 바로 알려 드려요. 레벨테스트만 받을 수도 있어요.</p>
          {chatList.map((one) => (
            <div key={one.id} className="user-menu__telegram-row">
              <span>✅ {one.teacher_name || one.telegram_name || "연결됨"}</span>
              <select value={one.scope} onChange={(event) => changeScope(one.id, event.target.value)}>
                {Object.entries(data.scope_label || {}).map(([value, label]) => (
                  <option key={value} value={value}>{label}</option>
                ))}
              </select>
              <button type="button" onClick={() => disconnect(one.id)}>끊기</button>
            </div>
          ))}
          <div className="user-menu__telegram-actions">
            <button type="button" className="user-menu__telegram-main" onClick={connect}>
              {data.my_connected ? "다른 기기 연결" : "텔레그램 연결"}
            </button>
            <button type="button" onClick={load}>연결 확인</button>
            {data.invite_url && (
              <button type="button" onClick={async () => {
                try { await navigator.clipboard.writeText(data.invite_url); } catch (error) { window.prompt("아래 주소를 복사해 주세요", data.invite_url); }
                setMessage("단톡용 연결 주소를 복사했어요. 선생님들이 누르고 '시작' 만 누르면 이어져요.");
              }}>단톡용 주소 복사</button>
            )}
            {chatList.length > 0 && (
              <button type="button" onClick={test}>테스트 보내기</button>
            )}
          </div>
          {message && <p className="user-menu__telegram-help">{message}</p>}
        </>
      )}
      {dialogOpen && (
        <TelegramConnectDialog onClose={() => { setDialogOpen(false); load(); }} onConnected={(next) => setData(next)} />
      )}
    </div>
  );
};

export default TelegramConnect;
